import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';

import {validarItem, validarFormulario} from './../utils/validar'; 
import Confirmar from '../components/ModalConfirmar'; 
import Cargando from './../components/Cargando';
import { FaSave , FaTrashAlt} from "react-icons/fa";
import Notificaciones from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';


import SelectCiclos from './../components/SelectCiclos'
import TablaAnuncios from './../components/TablaAnuncios';
import Botonera from './../components/BotoneraGuardar'; 
import fecha from './../utils/fecha';
import Anuncio from './../api/Anuncio'; 

const anuncio = new Anuncio(); 

class GestorAnuncios extends Component {
    _isMounted = false;
    constructor(props) {
        super(props); 
        this.state = {
            ciclo:'',
            data:[],
            titulo:'',
            contenido:'',
            fecha: fecha.Hoy(),
            id:'',
            usuario: this.props.user.rut,
            cargando: true,
            validacion: {
                ciclo:false,
                titulo:false,
                contenido:false
            },
            confirmarGuardar:false,
            confirmarEditar:false,
            confirmarBorrar:false,
            idBorrar:''
        }
 
    }

    manejaCiclo = (evento) => {
        this.setState({ciclo: evento.target.value})   
    }

	manejaCambio = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
    }


    estadoDefault = () => {
        this.setState({ 
            ciclo:'',
            titulo:'', 
            contenido:'', 
            id:'',
            validacion: {
                ciclo:false,
                titulo:false,
                contenido:false
            },
        });  
    }

    guardarEditarValidando = async ({validacion, confirmar}) =>{
        let validado = await validacion();

        if(validado.resultado){
            confirmar()
        }else{

            for (const k in validado.mensajes) {

                this.Notificaciones.addNotification({
                    message: validado.mensajes[k],
                    level: 'error',
                    position:'tr'
                });
                 
            }
    
        }  

    }

    mensajeGuardadoEditado = async ({resultado, mensaje, icono, tipo}) =>{
        if(resultado==="ok"){

            await this.cargarListadoAnuncios();
            this.estadoDefault();
            
            this.Notificaciones.addNotification({
                title: <FaSave/>,
                message: mensaje,
                level: 'success',
                position:'tr'
            });

        } else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });  
        }

        this.setState({cargando:false});   
    }


    validacionFormulario = async () => {
        let {ciclo, titulo, contenido} = this.state;

        let vCiclo        = validarItem({valor:ciclo, input:'Ciclo', select:true});
        let vTitulo       = validarItem({valor:titulo, input:'Título', vacio:true, largo:90});
        let vContenido    = validarItem({valor:contenido, input:'Contenido', vacio:true, largo:500});
    
        this.setState({ validacion:{
            ciclo:          !vCiclo.resultado, 
            titulo:         !vTitulo.resultado, 
            contenido:      !vContenido.resultado,
        } }); 
        
        let formulario = validarFormulario([vCiclo, vTitulo, vContenido]); 

        return formulario;

    }

    muestraConfirmarGuardar = () => {
        this.setState(prevState => ({
            confirmarGuardar: !prevState.confirmarGuardar
        }));    
    }

    ingresarAnuncio = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarGuardar   
        }); 
    }

    ingresarAnuncioBD = async () =>{
        this.setState({cargando:true});

        let {ciclo, titulo, contenido, fecha, usuario} = this.state;
        let resultado = await anuncio.ingresar(titulo, contenido, fecha, ciclo, usuario)
        
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Anuncio ingresado correctamente'})

    }


    editarAnuncio = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarEditar   
        }); 
    }

    muestraConfirmarEditar = () => {
        this.setState(prevState => ({
            confirmarEditar: !prevState.confirmarEditar
        }));    
    }


    editarAnuncioBD = async () =>{
        this.setState({cargando:true});

        let {id, titulo, contenido, fecha, ciclo, usuario} = this.state;
        let resultado = await anuncio.editar(id, titulo, contenido, fecha, ciclo, usuario)
        
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Anuncio editado correctamente'})

    }

    cargarEditar = (c) => {
        let cicloNombre = c.ciclo_nombre; 
        let CicloId = cicloNombre!==null?c.ciclo_id:'';
        this.setState({
            id: c.id, 
            titulo: c.titulo, 
            contenido: c.contenido, 
            ciclo:CicloId,
            validacion: {
                ciclo:false,
                titulo:false,
                contenido:false
            },
        }); 
    }

    cancelarEditar = () => {
        this.setState({ 
            ciclo:'',
            titulo:'', 
            contenido:'', 
            id:'',
            validacion: {
                ciclo:false,
                titulo:false,
                contenido:false
            },
            }); 
    }


    muestraConfirmarBorrar = (id) => {
        this.setState((prevState) => ({
            confirmarBorrar: !prevState.confirmarBorrar,
            idBorrar: id
        }));          
    }

    eliminarAnuncio = async () => {
        this.setState({cargando:true});
        
        let resultado = await anuncio.eliminar(this.state.idBorrar)

        if(resultado==="ok"){
            await this.cargarListadoAnuncios();
            
            this.Notificaciones.addNotification({
                title: <FaTrashAlt/>,
                message: 'Anuncio eliminado satisfactoriamente',
                level: 'info',
                position:'tr'
            });
        }else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });          
        }

       
        this.setState({cargando:false});
    }




    cargarListadoAnuncios = async() => {
       
        const {usuario} = this.state; 
         
        let listadoAnuncios = await anuncio.mostrar(usuario); 

        this.setState({data: listadoAnuncios, cargando:false});
      
    }
   
    componentDidMount () {
        this.cargarListadoAnuncios();

    }


    render(){
        const {ciclo, data, titulo, contenido, id, cargando, confirmarGuardar, confirmarEditar, confirmarBorrar, validacion} = this.state;
        return (

            <Page title="Administrador de anuncios" breadcrumbs={[ { name: 'Anuncios', active: true } ]}>
                <Cargando valor={cargando} />

                <Card>
                    <CardHeader>Información del anuncio</CardHeader>
                    <CardBody>
                    <Form>
        
                        <Row className="no-margin-bottom">
                            <Col  lg={2} md={4} sm={12}>
                                <FormGroup>
                                    <Label >Ciclo</Label>
                                    <SelectCiclos  maneja={this.manejaCiclo} ciclo={ciclo}  invalido={validacion.ciclo}/>  
                                </FormGroup>
                            </Col>

                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Título</Label>
                                    <Input
                                        type="text"
                                        onChange={this.manejaCambio}
                                        name="titulo"
                                        value={titulo}
                                        invalid={validacion.titulo}
                                        maxLength={90}
                                    />
                                </FormGroup>
                            </Col>

                            <Col  lg={7} md={4} sm={12}>
                                <FormGroup>
                                    <Label >Contenido</Label>
                                    <Input
                                        type="textarea"
                                        className="intextarea"
                                        onChange={this.manejaCambio}
                                        name="contenido"
                                        value={contenido}
                                        invalid={validacion.contenido}
                                        maxLength={500}
                                    />
                                </FormGroup>
                            </Col>

                        </Row>
            
                    </Form>
                    </CardBody>

                    <Botonera 
                        valor={id}
                        ingresar={this.ingresarAnuncio}
                        editar={this.editarAnuncio}
                        cancelar={this.cancelarEditar}
                    />


                </Card>


                <br/>

                <TablaAnuncios 
                    data={data}
                    //eliminar = {this.eliminarAnuncio}
                    eliminar = {this.muestraConfirmarBorrar}
                    editar = {this.cargarEditar}
                /> 
                 
                 <Confirmar 
                    isOpen={confirmarGuardar} 
                    toggle={this.muestraConfirmarGuardar} 
                    texto={"¿Esta seguro de guardar el anuncio?"} 
                    funcion={this.ingresarAnuncioBD} 
                />

                 <Confirmar 
                    isOpen={confirmarEditar} 
                    toggle={this.muestraConfirmarEditar} 
                    texto={"¿Esta seguro de editar el anuncio?"} 
                    funcion={this.editarAnuncioBD} 
                />

                 <Confirmar 
                    isOpen={confirmarBorrar} 
                    toggle={this.muestraConfirmarBorrar} 
                    texto={"¿Esta seguro de borrar el anuncio?"} 
                    funcion={this.eliminarAnuncio} 
                />



                <Notificaciones
                    dismissible={false}
                    ref={Notificaciones =>
                        (this.Notificaciones = Notificaciones)
                    }
                    style={NOTIFICATION_SYSTEM_STYLE}
                    />
        

            </Page>
        );
    };

}

export default GestorAnuncios;
